// extracted by mini-css-extract-plugin
module.exports = {"screenSmMin":"576px","screenSmMax":"575px","screenMdMin":"768px","screenMdMax":"767px","screenLgMin":"992px","screenLgMax":"991px","screenXlMin":"1280px","screenXlMax":"1279px"};